/* eslint-disable */
import React, {useEffect} from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import {DepartmentContainer, DepartmentList, Select, FormControl} from './styled'

const Department = (props) => {
    const {count, t, department} = props
    const {filter, setFilter} = props.filter
    // useEffect(() => {
    // 	setFilter({ department: [...department.map((x) => x.id)] })
    // }, [department])
    const departmentSaved = localStorage.getItem('department') || null

    async function departmentSavedF() {
        if (departmentSaved !== null) await setFilter({department: [parseInt(departmentSaved)]})
    }

    useEffect(() => {
        if (props.workflow) {
            departmentSavedF()
        } else {
            setFilter({
                department: props.department.map(x => x.id)
            })
        }
    }, [])

    const all = (Array.isArray(filter.department) && Array.isArray(props.department)) && filter.department.length === props.department.length


    function getCount(id) {
        let bot = 0,
            human = 0
        const x =
            Array.isArray(count) && count.length > 0
                ? count.filter((x) => x.department_id === id)[0]
                : {}
        x &&
        Object.keys(x).length > 0 &&
        Object.keys(x).map(
            (y) =>
                typeof x[y] === 'object' &&
                Object.keys(x[y]).map(
                    (z) =>
                        !/\W*(closed)\W*/.test(z) &&
                        z !== 'expired' &&
                        z !== 'in_day' &&
                        z !== 'will_delay' &&
                        (!props.auth || props.auth.role > 1 || z !== 'waiting') &&
                        (/\W*(bot)\W*/.test(z) ? (bot += x[y][z]) : (human += x[y][z]))
                )
        )
        return filter && filter.type === 'human' ? human : filter.type === 'bot' ? bot : bot + human
    }

    function getCountExpired(id) {
        let expired = false
        const x =
            Array.isArray(count) && count.length > 0
                ? count.filter((x) => x.department_id === id)[0]
                : {}
        x &&
        Object.keys(x).length > 0 &&
        Object.keys(x).map(
            (y) =>
                typeof x[y] === 'object' &&
                Object.keys(x[y]).map(
                    (z) => z === 'expired' && x[y][z] > 0 && (expired += x[y][z])
                )
        )

        return expired
    }

    function renderName(name) {
        const parts = name.split(' ')
        if (parts.length > 1) {
            return parts[0][0].toUpperCase() + parts[1][0].toUpperCase()
        }
        return parts[0].substr(0, 2).toUpperCase()
    }

    function saveDepartment(value) {
        localStorage.setItem('department', value)
    }

    return (
        <DepartmentContainer>
            <h5 className="department">
                {t.Department.title}
            </h5>
            <DepartmentList>
                <FormControl variant="outlined">
                {props.department &&
                <Select value={filter.department[0]}onChange={({target}) => {
                    if (props.workflow) saveDepartment(target.value)
                    setFilter({ department: [target.value],
                    })
                }}>{props.department.map(
                    (dept, index) =>
                        dept.actived && (
                            <MenuItem value={dept.id} key={`dept_${index}`}>

                                {dept.name}

                            </MenuItem>
                        )
                )}</Select>}
                </FormControl>
            </DepartmentList>
        </DepartmentContainer>
    )
}

export default Department
